import { Api } from '@jcd-web/basic-api';
export class DonationApi extends Api {
    static donate(donation) {
        let params = {};
        return this.client.post('/', donation);
    }
}
DonationApi.baseUrl = '/api/donations';
